import { requiredAddress, validatePoBox } from '../ShippingAddressForm/validations'
import { Country } from '@afterpay/types'
import { getAddressOptionalFields } from '@afterpay/utils'
import { InputAddressValidationRule, ProvidedAddress } from '@afterpaytouch/core'
import { AddressFieldSchema, FieldType, Schema } from '@afterpaytouch/form'
import { TFunction } from 'next-i18next'
import { app } from '../../env'
import { ConsumerState } from '../../state'
import { UpdateAccountDetails } from '../../model'
import { GetSchemaAndFormDataResult, VerifyAddressFormData, VerifyAddressFormSchema } from './types'

export const ALLOWED_ADDRESS_TYPES = ['street_address', 'subpremise', 'premise']

const getAddressFieldSchema = ({ value, error = false, otherProps = {}, options = {}, disabled = false }): AddressFieldSchema => ({
  type: FieldType.Address,
  apiKey: app.GOOGLEMAPS_API_KEY,
  show: true,
  props: {
    initialAddress: value,
    error,
    disabled,
    ...otherProps,
  },
  options,
})

export const getVerifyAddressPayload = (consumer: ConsumerState, formData: VerifyAddressFormData, defaultCountry: Country): UpdateAccountDetails => {
  return {
    ...formData.address,
    givenNames: consumer.profile?.givenNames ?? '',
    otherGivenNames: consumer.profile?.otherGivenNames ?? '',
    surname: consumer.profile?.surname ?? '',
    dateOfBirth: consumer.profile?.dateOfBirth ?? '',
    countryCode: (formData.address.countryCode ?? defaultCountry) as Country,
  }
}

export const getSchema = (components: any, t: TFunction, initialAddress: ProvidedAddress | ProvidedAddress[], country: Country): GetSchemaAndFormDataResult => {
  const schema: Schema<VerifyAddressFormSchema> = {
    address: getAddressFieldSchema({
      value: initialAddress,
      otherProps: {
        label: t('addNewAddress:addressInputLabel'),
        manualAddressLabel: t('addNewAddress:findAddressLabel'),
        address1Label: t('addNewAddress:address1Label'),
        address2Label: t('addNewAddress:address2Label'),
        postcodeLabel: t('addNewAddress:postcodeLabel'),
        componentRestrictions: { country },
        suburbLabel: t('addNewAddress:suburbLabel'),
        stateLabel: t('addNewAddress:stateLabel'),
        manualAddressLabelCaption: t('addNewAddress:findAddressLabelCaption'),
        optionalManualAddressFields: getAddressOptionalFields(country),
        allowedAddressType: ALLOWED_ADDRESS_TYPES,
        searchAddressLabel: t('addNewAddress:searchAddressLabel'),
        defaultExpanded: true,
        validateRule: InputAddressValidationRule.ByAddress,
      },
      options: {
        validate: {
          ...requiredAddress({ name: 'address', country, t }),
          ...validatePoBox(t('addNewAddress:error:invalid', { context: 'poBoxError' })),
        },
      },
    }),
    submit: {
      type: FieldType.Component,
      Component: components.submit,
    },
  }

  return { schema }
}
